import type { Environment } from '@/constants/environments';

/**
 * Decides whether the real analytics trackers (RudderStack, Clarity, Datadog,
 * Sentry, Google Analytics) should be registered.
 *
 * Real trackers are registered:
 *   - in any real (non-__DEV__) build, regardless of env; and
 *   - in dev builds whenever the resolved env is NOT production.
 *
 * They are withheld only in a dev build pointed at production, so local
 * development cannot pollute production analytics. QA/staging share a sandbox
 * data plane, so dev builds against those send to the sandbox — which is what
 * lets us verify tracking locally.
 */
export const shouldRegisterRealTrackers = (
  isDev: boolean,
  env: Environment,
): boolean => !isDev || env !== 'production';
